// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as TeamsRouteImport } from './routes/teams'
import { Route as MatchMatchIdRouteImport } from './routes/match.$matchId'
import { Route as MatchOpenersRouteImport } from './routes/match.openers'
import { Route as MatchMatchIdScorecardRouteImport } from './routes/match_.$matchId.scorecard'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const HistoryRoute = HistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => rootRouteImport
          })
const SettingsRoute = SettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => rootRouteImport
          })
const TeamsRoute = TeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => rootRouteImport
          })
const MatchMatchIdRoute = MatchMatchIdRouteImport.update({
            id: '/match/$matchId',path: '/match/$matchId',getParentRoute: () => rootRouteImport
          })
const MatchOpenersRoute = MatchOpenersRouteImport.update({
            id: '/match/openers',path: '/match/openers',getParentRoute: () => rootRouteImport
          })
const MatchMatchIdScorecardRoute = MatchMatchIdScorecardRouteImport.update({
            id: '/match_/$matchId/scorecard',path: '/match/$matchId/scorecard',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,HistoryRoute: HistoryRoute,SettingsRoute: SettingsRoute,TeamsRoute: TeamsRoute,MatchMatchIdRoute: MatchMatchIdRoute,MatchOpenersRoute: MatchOpenersRoute,MatchMatchIdScorecardRoute: MatchMatchIdScorecardRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)